module.exports = __webpack_public_path__ + "static/banner-image-1-1-74873bb202499e342acf5b70244a42f0.jpg";